// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TopTip_style_wrapper__1MVXl","left":"TopTip_style_left__2S_F6","icon":"TopTip_style_icon__1tHqZ","close":"TopTip_style_close__23DZt"};